import React, { useState, useEffect, Fragment, useRef, useMemo, useCallback } from "react";
import PropTypes from "prop-types";
import FormSection from "components/sales/formSection/formSection";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import FileUpload from "components/sales/fileUpload/fileUpload";
import localization from "assets/localization/localization";
import { handleValidateObj } from "constants/objValues/objvalues";
import RadioButton from "components/installation/dynamicForm/radioButton";
import ModalPop from "components/sales/modal/modal";
import Images from "assets/images/imageData";
import Camera from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";
import useLatLng from "hooks/uselatlng/uselatlng";
import { Button } from "react-bootstrap";
import axios from "services/interceptor/Interceptor";
import { toast } from "react-toastify";
import Loader from "components/sales/Loader/loader";

const Questions = ({
  data,
  formDatas,
  handleValue,
  documentUploadUrl,
  className,
  documentUploadUrlPublic,
}) => {
  const checklist = {
    id: "",
    answer: "",
    is_required: "",
    question_id: "",
  };

  const [formData, setformData] = useState(checklist);
  const [image, setImage] = useState(checklist);
  const [answers, setAnswers] = useState({});
  const [pic, setPic] = useState([]);
  const [newpic, setNewPic] = useState({});
  const [isModal, setIsModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const inputRef = useRef("");
  const islatlng = useLatLng();
  const [selfie, setSelfie] = useState("");
  const [selfieUrl, setSelfieUrl] = useState("");
  const [checkSelfieUrl, setCheckSelfieUrl] = useState("");
  const [retake, setRetake] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const canvasRef = useRef(null);
  const [isAllow, setIsAllow] = useState(false);
  const [selectSiteId, setSelectSiteId] = useState(0);
  const [mapLocation, setMapLocation] = useState({
    address: "Delhi",
    formatted_address: null,
    lat: 0,
    lng: 0,
  });
  const [picture, setPicture] = useState(checklist);
  var picArray = [];

  // Function to handle modal visibility
  const handleShowModal = (id) => {
    setSelectedId(id);  // Set the selected id
  };

  const handleCloseModal = () => {
    setSelectedId(null);  // Reset the selected id to close the modal
  };

  useEffect(() => {
    if(formDatas?.checklist_answers){
      const answerData = {};
        
        formDatas?.checklist_answers?.forEach(item => {
            if (item && item.answer && item.answer.file_url) {
                answerData[item.id] = item.answer.file_url; 
            }
        });

        setAnswers(answerData);
    }
  }, [formDatas]);

  const handlePicture = (selfie,id,is_q_required,question_id,keyId,latlngaa) => {
    if (selfie !== "" && canvasRef.current) {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");
      const img = new Image();
      img.src = selfie;

      img.onload = function () {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        ctx.font = "10px Arial";
        ctx.fillStyle = "rgba(0, 0, 0, 0.5)";
        const backgroundHeight = 80;
        ctx.fillRect(
          0,
          canvas.height - backgroundHeight,
          canvas.width,
          backgroundHeight
        );
        ctx.fillStyle = "white";
        const yBase = canvas.height - 70;
        ctx.fillText(
          `lat-long ( ${Number(islatlng?.lat)} , ${Number(islatlng?.lng)} )`,
          10,
          yBase
        );
        ctx.fillText(
          `Image taken at: ${currentDateTimeFormat()}`,
          10,
          yBase + 20
        );

        const maxWidth = canvas.width - 20;
        const lineHeight = 18;
        const address = `Address: ${mapLocation?.formatted_address}`;
        if (
          mapLocation?.formatted_address != null ||
          mapLocation?.formatted_address != undefined
        ) {
          wrapTextAddress(ctx, address, 10, yBase + 40, maxWidth, lineHeight);
        }

        (async () => {
          setIsLoading(true);
          const url = await documentUploadUrlPublic({
            base_64_file: canvas.toDataURL("image/png"),
          });

          if (url) {
            var newData = {
              question_id: question_id,
              url: url,
            };
            setNewPic(newData);

            setImage({
              ...image,
              answer: url,
              id: id,
              is_required: is_q_required,
              question_id: question_id,
            });

          }
          setIsLoading(false);
        })();
      };
    }
  };

  useEffect(() => {
    var list = [...pic];
    list.push(newpic); 
    setPic(list); 
  }, [newpic]);

  const handleQues = (val) => {
    const isNotEmpty = handleValidateObj(val);
    if (isNotEmpty !== false) {
      handleValue(val);
    }
  };
  useEffect(() => {
    handleQues(formData);
  }, [formData]);

  useEffect(() => {
    handleQues(image);
  }, [image]);

  function wrapTextAddress(ctx, text, x, y, maxWidth, lineHeight) {
    const words = text.split(" ");
    let line = "";
    for (let i = 0; i < words.length; i++) {
      const testLine = line + words[i] + " ";
      const testWidth = ctx.measureText(testLine).width;
      if (testWidth > maxWidth && i > 0) {
        ctx.fillText(line, x, y);
        line = words[i] + " ";
        y += lineHeight;
      } else {
        line = testLine;
      }
    }
    ctx.fillText(line, x, y);
  }

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await axios.get(
  //         `https://maps.googleapis.com/maps/api/geocode/json?latlng=${islatlng?.lat}, ${islatlng?.lng}&key=${process.env.REACT_APP_GOOGLE_API_KEY}`
  //       );
  //       if (
  //         response !== null &&
  //         response?.data !== null &&
  //         response?.data?.results?.length > 0 &&
  //         response?.data?.results[0]?.formatted_address !== null
  //       ) {
  //         console.log('reset');
  //         setMapLocation({
  //           ...mapLocation,
  //           formatted_address: response?.data?.results[0]?.formatted_address,
  //         });
  //       }
  //     } catch {
  //       toast.error("Google Map API failure");
  //       return;
  //     }
  //   };
  //   if (
  //     islatlng?.lat !== undefined &&
  //     islatlng?.lng !== undefined &&
  //     islatlng?.lat !== 0 &&
  //     islatlng?.lng !== 0 &&
  //     islatlng?.lat !== null &&
  //     islatlng?.lng !== null
  //   ) {
  //     fetchData();
  //   }
  // }, [islatlng]);

  useEffect(() => {
    if (selfie !== "" && canvasRef.current) {
      console.log('is iam first');
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");
      const img = new Image();
      img.src = selfie;

      img.onload = function () {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        ctx.font = "10px Arial";
        ctx.fillStyle = "rgba(0, 0, 0, 0.5)";
        const backgroundHeight = 80;
        ctx.fillRect(
          0,
          canvas.height - backgroundHeight,
          canvas.width,
          backgroundHeight
        );
        ctx.fillStyle = "white";
        const yBase = canvas.height - 70;
        console.log("ISLATLONG: ", islatlng)
        ctx.fillText(
          `lat-long ( ${Number(islatlng?.lat)} , ${Number(islatlng?.lng)} )`,
          10,
          yBase
        );
        ctx.fillText(
          `Image taken at: ${currentDateTimeFormat()}`,
          10,
          yBase + 20
        );

        const maxWidth = canvas.width - 20;
        const lineHeight = 18;
        const address = `Address: ${mapLocation?.formatted_address}`;
        if (
          mapLocation?.formatted_address != null ||
          mapLocation?.formatted_address != undefined
        ) {
          wrapTextAddress(ctx, address, 10, yBase + 40, maxWidth, lineHeight);
        }

        (async () => {
          setIsLoading(true);
          const url = await documentUploadUrlPublic({
            base_64_file: canvas.toDataURL("image/png"),
          });
          if (url) {
            setCheckSelfieUrl(url);
          }
          setIsLoading(false);
        })();
      };
    }
  }, [selfie]);

  const currentDateTimeFormat = () => {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();
    let hours = now.getHours();
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const isPM = hours >= 12;
    const ampm = isPM ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${day}/${month}/${year} ${hours}:${minutes} ${ampm}`;
  };

  const handleClickPicture = () => {
    setIsModal(true);
  };

  useEffect(() => {
    if (checkSelfieUrl?.file_url !== undefined) {
      setSelfieUrl(checkSelfieUrl?.file_url);
    }
  }, [checkSelfieUrl]);

  const handleModalHide = () => setIsModal(false);

  const handlePictureSubmit = () => {
    setPicture(selfieUrl);
  };

  useEffect(() => {
    handleQues(selfieUrl);
  }, [selfieUrl]);

  const memoizedCameraComponent = useMemo(() => {
    return (params) => (
      <>
      <Camera
        idealFacingMode={"environment"}
        idealResolution={{ width: 400, height: 200 }}
        onTakePhoto={(dataUrl) => {
          setIsLoading(true);
          handlePicture(
            dataUrl,
            params.selfieId,
            params.isQuestionRequired,
            params.questionId,
            params.testId,
            islatlng

          );
          setRetake(false);
          setIsLoading(false);
        }}
      />
      </>
    );
  }, [retake,islatlng]);
  
  const cameraComponent = (selfieId, isQuestionRequired, questionId, testId) => memoizedCameraComponent({
    selfieId,
    isQuestionRequired,
    questionId,
    testId,
  });

  //console.log("RETAKE TEST: ", retake)

  return (
    <Fragment>
     
      {data &&
        data.map((obj, index) => {
          return (
            <>
              <FormSection title={obj.name} key={index}>
                <div
                  className={`details-listing faq-listing ${
                    !className ? "not-filled" : ""
                  }`}
                >
                  {obj.questions.map((item, index1) => {
                    return (
                      <div className="details-list question-input" key={index1}>
                        <label className="data-title">
                          {item.questions}
                          {/* {item.required && (
                          <span style={{ color: 'red' }}> * </span>
                        )} */}
                        </label>
                        {item.types.map((el, id) => {
                          if (el.type === "text" || el.type === "Number") {
                            return (
                              <ConstantInput
                                key={id}
                                type={el.type}
                                label={el.label}
                                required={el.is_q_required}
                                isStarRequired={
                                  el.is_q_required == 1 ? true : false
                                }
                                // className={(el.is_q_required == 1)?"activeInput":""}
                                errorMsg={localization.questionRequired}
                                handleChange={(val) => {
                                  setformData({
                                    ...formData,
                                    answer: val,
                                    id: el.id,
                                    is_required: el.is_q_required,
                                    question_id: item.question_id,
                                  });
                                }}
                              />
                            );
                          } else if (el.type.toLowerCase() === "radio") {
                            return (
                              <Fragment key={id}>
                                <RadioButton
                                  el={el}
                                  item={item}
                                  onHandle={(val) => {
                                    setformData(val);
                                  }}
                                  className={className}
                                />
                                <br />
                              </Fragment>
                            );
                          } else if (el.type === "File") {
                            return (
                              <Fragment key={id}>
                                <div className="sub-question">
                                  <label className="label">
                                    <>
                                      {el.is_q_required ? (
                                        <span style={{ color: "red" }}>
                                          <span style={{ color: "black" }}>
                                            {el.label}
                                          </span>{" "}
                                          *{" "}
                                        </span>
                                      ) : (
                                        <span>{el.label} </span>
                                      )}
                                    </>
                                  </label>

                                  <FileUpload
                                    ref={inputRef}
                                    multiple={true}
                                    key={id}
                                    id={`item${el.label}${el.id}`}
                                    documentUploadUrl={documentUploadUrl}
                                    capture={false}
                                    is_required={el.is_q_required}
                                    onChange={(val) => {
                                      setImage({
                                        ...image,
                                        answer: val,
                                        id: el.id,
                                        is_required: el.is_q_required,
                                        question_id: item.question_id,
                                      });
                                      // setformData({
                                      //   ...formData,
                                      //   answer: val,
                                      //   id: el.id,
                                      //   is_required: true,
                                      // });
                                      inputRef.current = val;
                                    }}
                                  >
                                    <span className="btn btn-transparent">{`Select ${el.label}`}</span>
                                  </FileUpload>
                                  <label
                                    className={`error ${
                                      inputRef.current === "" &&
                                      el.is_q_required &&
                                      className
                                        ? "d-block"
                                        : ""
                                    }`}
                                  >
                                    {localization.requiredErrorMg}
                                  </label>
                                </div>
                              </Fragment>
                            );
                          } else if (el.type === "Camera") {
                            return (
                              <Fragment key={id}>
                                <label className="label">
                                    <>
                                      {el.is_q_required ? (
                                        <span style={{ color: "red" }}>
                                          <span style={{ color: "black" }}>
                                            {`Take Picture`}
                                          </span>{" "}
                                          *{" "}
                                        </span>
                                      ) : (
                                        <span>{`Take Picture`} </span>
                                      )}
                                    </>
                                  </label>

                                {answers[el.id] !== undefined && answers[el.id] !== '' ? (
                                  <button
                                    className="btn btn-primary btn-sm"
                                    // onClick={handleClickPicture}
                                    onClick={() => handleShowModal(el.id)}
                                  >
                                    Retake Picture
                                  </button>
                                ): (
                                  <button
                                    className="btn btn-primary btn-sm"
                                    // onClick={handleClickPicture}
                                    onClick={() => {
                                      handleShowModal(el.id)
                                      setRetake(true)
                                    }}
                                  >
                                    Take Picture
                                  </button>
                                )} 
                                
                                {selectedId === el.id && (
                                  <ModalPop
                                  title={`Take Picture (${islatlng.lat}, ${islatlng.lng})`}
                                    show={true}
                                    handleModalHide={handleCloseModal}
                                    keyboard
                                    backdrop
                                  >
                                    <Loader isLoading={isLoading} />
                                    <div className="row" style={{ justifyContent: "center" }}>
                                      <div className="">
                                        <canvas
                                          ref={canvasRef}
                                          width="400"
                                          height="200"
                                          style={{
                                            display: "none",
                                            border: "1px solid black",
                                            marginTop: "20px",
                                          }}
                                        ></canvas>
                                        
                                        {(answers[el.id] !== undefined) ? (
                                          <>
                                          
                                            <img src={`${answers[el.id]}`} alt={""} />
                                            <div className="container mt-4 center">
                                              <Button
                                                className="btn-sm"
                                                style={{ marginLeft: "46%" }}
                                                onClick={() => {
                                                  setRetake(true);
                                                  setSelfieUrl("");
                                                  setSelfie("");
                                                  delete answers[el.id];
                                                  setAnswers(answers)
                                                }}
                                              >
                                                {"Retake"}
                                              </Button>
                                            </div>
                                          </>
                                        ) : (
                                          retake && (
                                            cameraComponent(el.id, el.is_q_required, item.question_id, id)
                                            // <Camera
                                            //   idealFacingMode={"environment"}
                                            //   idealResolution={{ width: 400, height: 200 }}
                                            //   onTakePhoto={(dataUri) => {
                                            //     setIsLoading(true);
                                            //     handlePicture(
                                            //       dataUri,
                                            //       el.id,
                                            //       el.is_q_required,
                                            //       item.question_id,
                                            //       id
                                            //     );
                                            //     // setSelfie(dataUri);
                                            //     setRetake(false);
                                            //     setIsLoading(false);
                                            //   }}
                                            // />
                                          )
                                        )}
                                      </div>
                                    </div>
                                  </ModalPop> 
                                )}
                                
                                <br />
                              </Fragment>
                            );
                          }
                        })}
                      </div>
                    );
                  })}
                </div>
              </FormSection>
            </>
          );
        })}
      
    </Fragment>
  );
};

export default Questions;
